//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('furnitureFabricsColors', {
//        templateUrl: 'views/components/views/furnitureFabricsColors/furnitureFabricsColors.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'furnitureFabricsColorsService', function ($stateParams, stateService, utilityService, furnitureFabricsColorsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let furnitureFabricsId = $stateParams.furniturefabrics_id

//            vm.model = {
//                setting: {},
//                itemsListColours: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await furnitureFabricsColorsService.getSetting({ furniturefabrics_id: furnitureFabricsId }))[0];

//                loadFurnitureFabricsColors();
//            }

//            async function loadFurnitureFabricsColors() {
//                if (utilityService.validateParmsValue(vm.model.setting.furniturefabrics_id) !== true) return;

//                vm.model.itemsListColours = [];

//                vm.model.itemsListColours = (await furnitureFabricsColorsService.listFurnitureFabricsColors({ furniturefabrics_id: vm.model.setting.furniturefabrics_id }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'furniturefabricscolor':
//                        go({
//                            furniturefabrics_id: vm.model.setting.furniturefabrics_id,
//                            furniturefabricscolor_id: '+'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
